module.exports = __webpack_public_path__ + "static/media/icon-my-location.6b89a298.png";